"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const zod_1 = require("zod");
const httpRepository_1 = __importDefault(require("./httpRepository"));
const _CompanyFeatureSchema = zod_1.z.strictObject({
    ENABLE_COMPANY_PEOPLE_VIEW: zod_1.z.boolean().optional(),
    ENABLE_DOMAIN_WHITELISTING: zod_1.z.boolean().optional(),
    ENABLE_FILTERED_BY_COSTCENTER: zod_1.z.boolean().optional(),
    ENABLE_GLOBALIZATION: zod_1.z.boolean().optional(),
    ENABLE_OUT_OF_OFFICE_FORWARDING: zod_1.z.boolean().optional(),
    ENABLE_MULTIUSE: zod_1.z.boolean().optional(),
    ENABLE_SINGLEUSE: zod_1.z.boolean().optional(),
    ENABLE_SUBSCRIPTIONS: zod_1.z.boolean().optional(),
    ENABLE_TRANSACTION_RECEIPT_UPLOAD: zod_1.z.boolean().optional(),
    ENABLE_USER_APPROVAL_LIMITS: zod_1.z.boolean().optional(),
    ENABLE_VIRTUAL_CARD_EXP_RANGE: zod_1.z.boolean().optional(),
    PAUSE_VIRTUAL_CARD_CREATION: zod_1.z.boolean().optional(),
    ENABLE_API_INTEGRATION: zod_1.z.boolean().optional(),
});
const featureRepository = {
    getFeaturesList: async () => {
        const response = await httpRepository_1.default.tradeshiftGo().get('/rest/features');
        return response.data;
    },
};
exports.default = featureRepository;
